import { useLanguage } from "../../../../contexts/LanguageContext";
import { useUserSearchPartQuery } from "../../../../api/endpoints/parts";

const useProductSearch = (params = {}) => {
  const { getCurrentLanguageId } = useLanguage();
  const currentLanguageId = getCurrentLanguageId();

  const {
    page = 1,
    rows = 10,
    partCode = null,
    partName = null
  } = params;

  const { data, isLoading, refetch } = useUserSearchPartQuery(
    {
      languageId: currentLanguageId,
      partCode,
      partName,
      pageNumber: page,
      pageSize: rows
    },
    {
      refetchOnMountOrArgChange: true
    }
  );

  const products = data?.data?.items ?? [];
  const totalRecords = data?.data?.totalCount ?? 0;

  return { products, totalRecords, isLoading, refetch };
};

export default useProductSearch;
